export default "__VITE_ASSET__xJVUTYOJ__"